import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { HttpService } from 'src/app/services/http.service';
import { LoadingService } from 'src/app/services/loading.service';
import { environment } from 'src/environments/environment';
import Sortable from 'sortablejs';
import { Swap } from 'sortablejs';
import { Location } from '@angular/common';

@Component({
    selector: 'app-wppsi-visual-spatial-index',
    templateUrl: './wppsi-visual-spatial-index.component.html',
    styleUrls: ['./wppsi-visual-spatial-index.component.scss']
})
export class WppsiVisualSpatialIndexComponent implements OnInit {

    constructor(
        private http: HttpService,
        public loading: LoadingService,
        private location: Location
    ) { }
    @ViewChild('puzzleWrapper') puzzleWrapper!: ElementRef;
    data: any[] = [];
    numberOfQuiz: number = 1;
    totalQuiz: number = 0;
    percentQuiz: string = '0';
    currentQuiz: any = {};
    currentAnswer: any[] = [];
    assetUrl: any = null;
    point: number = 0;
    elapsedTime: number = 0;
    isDone: boolean = false;
    startTime: number = 0;
    endTime: number = 0;
    countDownInterval: any = null;
    countDown: number = 3;
    puzzleLib: Sortable | null = null;
    isOk = false;
    graphImage: any = null;
    timeOutQuiz: number = 15000; // in miliseconds
    currentTimeOut: number = 0;
    timeOutInterval: any = null;
    percentTimeOut: any = '0';
    nextTimeout: any = null;

    async getData(): Promise<void> {
        const r = await this.http.Get('quiz/wppsi/visual-spatial-index', {}, true);
        if (!r.success) {
            this.location.back();
            return;
        }
        this.data = r.response?.result?.data || [];
        this.graphImage = r.response?.result?.image || null;
        console.log(this.data);
        this.totalQuiz = this.data.length || 1;
        this.percentQuiz = ((this.numberOfQuiz / this.totalQuiz) * 100).toFixed(0);
        this.loading.done();
        this.countDownInterval = setInterval(() => {
            this.countDown--;
            if (this.countDown <= 0) {
                this.playQuiz();
                clearInterval(this.countDownInterval);
            }
        }, 1000);
        Sortable.mount(new Swap());
    }

    playQuiz(): void {
        this.startTime = (new Date()).getTime();
        this.currentQuiz = this.data[this.numberOfQuiz - 1] || {};
        this.createPuzzle();
        this.playAudio();
        clearInterval(this.timeOutInterval);
        this.currentTimeOut = 0;
        this.timeOutInterval = setInterval(() => {
            if (this.currentTimeOut < this.timeOutQuiz) {
                this.currentTimeOut += 100;
            } else {
                clearInterval(this.timeOutInterval);
            }
            this.percentTimeOut = ((this.currentTimeOut / this.timeOutQuiz) * 100).toFixed(0);
        }, 100);
        this.nextTimeout = setTimeout(() => {
            this.endTime = (new Date()).getTime();
            this.elapsedTime += (this.endTime - this.startTime);
            this.nextQuiz();
        }, this.timeOutQuiz);
    }

    nextQuiz(): void {
        if (this.numberOfQuiz >= this.totalQuiz) {
            this.isDone = true;
            this.postResult();
            return;
        }
        this.numberOfQuiz++;
        this.percentQuiz = ((this.numberOfQuiz / this.totalQuiz) * 100).toFixed(0);
        this.playQuiz();
    }

    createPuzzle(): void {
        if (this.puzzleLib != null) {
            this.puzzleLib.destroy();
        }
        this.isOk = false;
        this.puzzleWrapper.nativeElement.innerHTML = '';
        const percentage = 100 / (this.currentQuiz.grid - 1);
        let subEl: any[] = [];
        for (var i = 0; i < this.currentQuiz.grid * this.currentQuiz.grid; i++) {
            const xpos = (percentage * (i % this.currentQuiz.grid)) + '%';
            const ypos = (percentage * Math.floor(i / this.currentQuiz.grid)) + '%';
            subEl.push({
                i: i, el: `<div ngDraggable class="puzzle-item" data-value="${i}" style="
                            display:inline-block;
                            background-image:url('${this.assetUrl + this.currentQuiz.question}');
                            background-size:${(this.currentQuiz.grid * 100)}%;
                            background-position:${xpos} ${ypos};
                            width: ${320 / this.currentQuiz.grid}px;
                            height: ${320 / this.currentQuiz.grid}px;
                            "></div>`
            });
        }
        this.randomizeItem(subEl).forEach((e: any) => {
            this.puzzleWrapper.nativeElement.insertAdjacentHTML('beforeend', e.el);
        });
        this.puzzleLib = new Sortable(this.puzzleWrapper.nativeElement, {
            swap: true,
            invertSwap: false,
            animation: 150,
            easing: 'cubic-bezier(0.4, 0, 0.2, 1)',
            ghostClass: 'blue-background-class',
            onSort: (evt) => {
                let idx: number[] = Array.from(evt.target.children).map((e: any) => Number(e.getAttribute('data-value')));
                if (this.isSorted(idx)) {
                    this.isOk = true;
                    this.endTime = (new Date()).getTime();
                    this.elapsedTime += (this.endTime - this.startTime);
                    clearTimeout(this.nextTimeout);
                    clearInterval(this.timeOutInterval);
                    setTimeout(() => {
                        this.puzzleLib?.destroy();
                        this.puzzleLib = null;
                        this.answerQuiz();
                    }, 1800);
                }
            },
        });
    }

    isSorted(arr: number[]): boolean {
        return arr.every((v, i, a) => !i || a[i - 1] <= v);
    }

    randomizeItem(arr: any[]): any {
        arr.sort(() => Math.random() - 0.5);
        if (this.isSorted(arr.map(e => e.i))) {
            return this.randomizeItem(arr);
        } else {
            return arr;
        }
    }

    answerQuiz(): void {
        if (this.isDone) {
            this.postResult();
            return;
        }
        this.point += this.currentQuiz.point;
        this.nextQuiz();
    }

    async postResult(): Promise<void> {
        let seconds = this.elapsedTime;
        let d = new Date(0);
        d.setMilliseconds(seconds);
        let ts = d.toISOString().substring(11, 23) + '000';
        this.http.SaveQuiz('WPPSI', 'Visual Spatial Index', this.point, ts);
    }

    playAudio(): void {
        if (!this.currentQuiz.voice) {
            return;
        }
        let audio = new Audio(this.assetUrl + this.currentQuiz.voice);
        audio.play();
    }

    ngOnInit(): void {
        this.loading.start();
        this.assetUrl = environment.assetUrl;
        this.getData();
    }

    ngOnDestroy(): void {
        clearInterval(this.countDownInterval);
        clearTimeout(this.nextTimeout);
        clearInterval(this.timeOutInterval);
    }

}
